import React from "react";
import userImage from "../../../../assets/user.png";
import { Image } from "react-bootstrap";

export default function SingleKit({ leftName, leftValue, rightName, rightValue }) {
  return (
    <div className="historyContentSingle">
      <div className="historyContentDoctor">
        <Image src={userImage} width={50} height={50} />
        <div>
          <div className="name">{leftName}</div>
          <div className="designation">{leftValue}</div>
        </div>
      </div>

      <div className="treatmentInfo">
        <div className="name">{rightName}</div>
        <div className="designation">{rightValue}</div>
      </div>
    </div>
  );
}
